// Single source of truth for the Voice Broadcast realtime cards.
//
// The two sides speak different dialects: /voicebroadcast_realtime/list returns
// `count_data` as a single object keyed `new_count` / `ringing_count` / `answer_count`,
// while each listing row carries a display string in `row.type` ('New' / 'Ringing' /
// 'Answer'). Clicking a card filters the listing, so the pairing lives here once instead
// of being restated in the card and the list components.
//
// `rowType: null` marks the card that clears the filter rather than applying one.

export const TOTAL_STATUS_KEY = 'total';

// Order here is the order the cards render in, and matches what the page showed before.
export const BROADCAST_STATUS_CARDS = [
  { key: 'new_count', title: 'New', color: '#2cabe3', icon: 'Slash', rowType: 'New' },
  { key: 'ringing_count', title: 'Ringing', color: '#6376ff', icon: 'Rss', rowType: 'Ringing' },
  {
    key: 'answer_count',
    title: 'Answer',
    color: '#008000',
    icon: 'PhoneForwarded',
    rowType: 'Answer'
  },
  { key: TOTAL_STATUS_KEY, title: 'Total', color: '#122335', icon: 'Phone', rowType: null }
];

export const getBroadcastCard = (key) => BROADCAST_STATUS_CARDS.find((card) => card.key === key);

export const filterRowsByStatus = (rows = [], statusKey) => {
  const card = statusKey ? getBroadcastCard(statusKey) : null;
  if (!card?.rowType) return rows;
  return rows.filter((row) => row.type === card.rowType);
};

// `count_data` arrives as a one-element array holding the counts object.
export const buildBroadcastCounts = (data = []) => {
  const source = data?.[0] || {};

  const counts = BROADCAST_STATUS_CARDS.reduce((acc, card) => {
    if (card.rowType) {
      acc[card.key] = parseInt(source[card.key], 10) || 0;
    }
    return acc;
  }, {});

  counts[TOTAL_STATUS_KEY] = Object.values(counts).reduce((sum, count) => sum + count, 0);
  return counts;
};
